import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
//import DriversComponent from "../DriversOld/DriversComponent";
import "./SettlementsPOC.scss";
import Sidebar from "app/views/commonComponents/Sidebar/Sidebar";
import { Container } from "reactstrap";
import Breadcrumbs from "app/views/commonComponents/Breadcrumb/Breadcrumbs";
import Title from "app/views/commonComponents/Title/Title";
import DetailsHeader from "../../../../commonComponents/DetailsHeader/DetailsHeader";
import driverProfile from "../../../../../../assets/images/drivers/driverProfile.svg";
import accidents from "../../../../../../assets/images/drivers/accidents.svg";
import star from "../../../../../../assets/images/drivers/star.svg";
import userTag from "../../../../../../assets/images/drivers/userTag.svg";
import TabButtons from "app/views/commonComponents/TabButtons/TabButtons";
import DriversTablePOC from "../../TablePOC/TablePOC";
//import DriversFilterButton from "../DriversFilterButton/DriversFilterButton";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import addIcon from "../../../../../../assets/images/poc/addIcon.svg";
import searchIcon from "../../../../../../assets/images/poc/searchIcon.svg";
import helloImage from "../../../../../../assets/images/poc/helloImage.png";
import CalenderChanger from "app/views/commonComponents/CalendarChanger/CalendarChanger";
import moment from "moment-timezone";
import grossRevenueGradient from "../../../../../../assets/images/poc/grossRevenueGradient.svg";
import grossMarginGradient from "../../../../../../assets/images/poc/grossMarginGradient.svg";
import rpmGradient from "../../../../../../assets/images/poc/rpmGradient.svg";
import driverPaymentsGradient from "../../../../../../assets/images/poc/driverPaymentsGradient.svg";
import milesLoadedGradient from "../../../../../../assets/images/poc/milesLoadedGradient.svg";
import loadsDeliveredGradient from "../../../../../../assets/images/poc/loadsDeliveredGradient.svg";
import {
  getDashboardDetailsHeaderKPIData,
  getWeeklySettlementsData,
} from "../../../../../apiServices/apiServices";
const SettlementsPOC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeCalendarTab, setActiveCalendarTab] = useState(0);
  const [maxTableHeight, setMaxTableHeight] = useState(0);
  const [isDriversFilterOpen, setIsDriversFilterOpen] = useState(false);
  const [settlementsOriginalData, setSettlementsOriginalData] = useState([]);
  const [settlementsUploadId, setSettlementsUploadId] = useState("");
  const [firstNameUser, setFirstNameUser] = useState("");
  const [lastNameUser, setLastNameUser] = useState("");
  const [grossRevenue, setGrossRevenue] = useState(0);
  const [driverPayments, setDriverPayments] = useState(0);
  const [grossMargin, setGrossMargin] = useState(0);
  const [headerRPM, setHeaderRPM] = useState(0);
  const [milesLoaded, setMilesLoaded] = useState(0);
  const [loadsDelivered, setLoadsDelivered] = useState(0);
  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Drivers", link: "/drivers" },
  ];
  const driverData = [
    {
      icon: grossRevenueGradient,
      values: `$${Math.round(grossRevenue).toLocaleString("en-US")}`,
      title: "Gross Revenue",
    },
    {
      icon: driverPaymentsGradient,
      values: `$${Math.round(driverPayments).toLocaleString("en-US")}`,
      title: "Driver Payments",
    },
    {
      icon: grossMarginGradient,
      values: `$${Math.round(grossMargin).toLocaleString("en-US")}`,
      title: "Gross Margin",
    },
    {
      icon: rpmGradient,
      values: `$${headerRPM.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
      title: "RPM",
    },
    {
      icon: milesLoadedGradient,
      values: milesLoaded.toLocaleString("en-US"),
      title: "Loaded Miles",
    },
    {
      icon: loadsDeliveredGradient,
      values: loadsDelivered.toLocaleString("en-US"),
      title: "Delivered Loads",
    },
    //{ icon: accidents, values: "72", title: "Loads" },
    // { icon: calendarRemove, values: "13", title: "Near Expirations" },
    // { icon: moneys, values: "$3.54", title: "Avg. RPM" },
    // { icon: presentionChart, values: "86.3%", title: "Avg. RPM" },
    // Add more data items as needed
  ];
  const calendarTabsData = [
    { id: 0, label: "Month" },
    { id: 1, label: "Quarter" },
    { id: 2, label: "Year" },
    // Add more tabs as needed
  ];
  const settlementsTableHeaders = {
    settlementDate: "Settlement Date",
    totalLoad: "Loads",
    totalDriver: "Drivers",
    totalRevenue: "Load Revenue",
    totalOtherRevenue: "Other Revenue",
    totalDeduction: "Deductions",
    driverPayments: "Driver Payments",
  };
  const settlementsTableData = settlementsOriginalData.map((item, index) => {
    const originalDateString = item.statement_date;
    let originalDate = moment.utc(originalDateString);
    const month = moment(originalDate).format("MMM");
    const day = moment(originalDate).format("DD");
    const year = moment(originalDate).year();
    const formattedDate = `${month} ${day}, ${year}`;
    return {
      settlementDate: `${formattedDate}`,
      totalLoad: item.total_load_count.toLocaleString(),
      totalDriver: item.total_drivers.toLocaleString(),
      totalRevenue: `$${item.total_revenue.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
      totalOtherRevenue: `$${item.total_other_revenue.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} • ${item.total_other_income_count.toLocaleString("en")}`,
      totalDeduction: `$${item.total_deduction.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} • ${item.total_deduction_count.toLocaleString("en")}`,
      // totalOtherRevenue: `$${item.total_other_revenue.toLocaleString("en", {
      //   minimumFractionDigits: 2,
      //   maximumFractionDigits: 2,
      // })}`,
      // totalDeduction: `$${item.total_deduction.toLocaleString("en", {
      //   minimumFractionDigits: 2,
      //   maximumFractionDigits: 2,
      // })}`,
      driverPayments: `$${item.driver_payment.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
      uploadId: item._id,
    };
  });
  const handleTabChange = (tabId) => {
    setActiveCalendarTab(tabId);
  };
  // Function to handle month change
  const handleDateChange = (startDate, endDate) => {
    console.log("currentNewDate1", startDate);
    console.log("currentNewDate2", endDate);
    // Call getDetailsHeaderKPIDataAPI with final start and end dates
    getDetailsHeaderKPIData(startDate, endDate);
  };
  useEffect(() => {
    handleReturnSettelmentsPOC();
    const calculateMaxTableHeight = () => {
      // Get the window height
      const windowHeight = window.innerHeight;
      // Calculate the available height by subtracting the height of other elements if necessary
      const availableHeight =
        windowHeight - 332; /* subtract other elements height */
      // Set the max height of the table container
      setMaxTableHeight(availableHeight);
    };

    // Call the function initially and on window resize
    calculateMaxTableHeight();
    window.addEventListener("resize", calculateMaxTableHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateMaxTableHeight);
    };
  }, []);
  useEffect(() => {
    // Retrieve the data from localStorage
    const authUserData = localStorage.getItem("authUser");

    // Check if the data exists
    if (authUserData) {
      // Parse the JSON string back into a JavaScript object
      const userData = JSON.parse(authUserData);
      // setUserDetails(userData);
      // Now you can access the properties of the userData object
      console.log("userData", userData);
      console.log("userData2", userData.first_name);
      setFirstNameUser(userData.first_name);
      console.log("userData3", userData.last_name);
      setLastNameUser(userData.last_name);
    } else {
      // Handle the case where the data doesn't exist in localStorage
      console.log("No user data found in localStorage");
    }
    if (
      activeCalendarTab == 0 ||
      activeCalendarTab == 1 ||
      activeCalendarTab == 2
    ) {
      getDetailsHeaderKPIData();
    }
    getWeeklySettlementsDataAPI();
  }, [activeCalendarTab]);
  const getWeeklySettlementsDataAPI = () => {
    const storedToken = localStorage.getItem("token");
    const limit = 0;
    // fetch(
    //   "https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/weekly/settlements",
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getWeeklySettlementsData(limit)
      .then((response) => {
        //console.log("insideif", response);
        console.log("WeeklySettlementsData1", response.data);
        setSettlementsOriginalData(response.data ? response.data : "");
        setSettlementsUploadId(response.data._id ? response.data._id : "");
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const getDetailsHeaderKPIData = (startDate, endDate) => {
    console.log("currentNewDate5", startDate);
    console.log("currentNewDate6", endDate);
    let currentStartDate = null;
    let currentEndDate = null;

    const currentDate = moment();
    const currentYear = currentDate.year();
    const currentMonth = currentDate.month() + 1; // Month index starts from 0

    switch (activeCalendarTab) {
      case 0: // Current month
        currentStartDate = moment().startOf("month").format("YYYY-MM-DD");
        currentEndDate = moment().endOf("month").format("YYYY-MM-DD");
        break;
      case 1: // Current quarter
        const currentQuarter = Math.floor((currentMonth - 1) / 3) + 1;
        const quarterStartMonth = (currentQuarter - 1) * 3;
        currentStartDate = moment().startOf("quarter").format("YYYY-MM-DD");
        currentEndDate = moment().endOf("quarter").format("YYYY-MM-DD");
        break;
      case 2: // Current year
        currentStartDate = moment().startOf("year").format("YYYY-MM-DD");
        currentEndDate = moment().endOf("year").format("YYYY-MM-DD");
        break;
      default:
        break;
    }
    console.log("currentNewDate3", currentStartDate);
    console.log("currentNewDate4", currentEndDate);
    // Use current dates if no startDate or endDate provided
    const finalStartDate = startDate || currentStartDate;
    const finalEndDate = endDate || currentEndDate;
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/dashboard/kpi?start_date=${startDate}&end_date=${endDate}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getDashboardDetailsHeaderKPIData(finalStartDate, finalEndDate)
      .then((response) => {
        //console.log("insideif", response);
        console.log("DetailsHeaderKPIData", response.data);
        console.log("DetailsHeaderKPIData1", response.data.gross_revenue);
        setGrossRevenue(response.data.gross_revenue);
        setDriverPayments(response.data.driver_payments);
        setGrossMargin(response.data.gross_margin);
        setHeaderRPM(response.data.rpm);
        setMilesLoaded(response.data.miles_loaded);
        setLoadsDelivered(response.data.loads_delivered);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const [currentPageSettlementsPOC, setCurrentPageSettlementsPOC] = useState(1);
  const [itemsPerPageSettlementsPOC, setItemsPerPageSettlementsPOC] =
    useState(50);
  const handlePageChange = (pageNumber) => {
    setCurrentPageSettlementsPOC(pageNumber);
  };
  const handleItemsPerPageChange = (perPage) => {
    setItemsPerPageSettlementsPOC(perPage);
    setCurrentPageSettlementsPOC(1); // Reset to the first page when changing items per page
  };
  const handleNavigateAway = () => {
    // Save current page and items per page
    // You can save these values to local storage or any other persistent storage
    localStorage.setItem(
      "currentPageSettlementsPOC",
      currentPageSettlementsPOC
    );
    // localStorage.setItem(
    //   "itemsPerPageSettlementsPOC",
    //   itemsPerPageSettlementsPOC
    // );
  };
  const handleReturnSettelmentsPOC = () => {
    // Retrieve saved page and items per page
    const savedPage = localStorage.getItem("currentPageSettlementsPOC");
    // const savedItemsPerPage = localStorage.getItem(
    //   "itemsPerPageSettlementsPOC"
    // );
    setCurrentPageSettlementsPOC(savedPage ? parseInt(savedPage) : 1);
    // setItemsPerPageSettlementsPOC(
    //   savedItemsPerPage ? parseInt(savedItemsPerPage) : 50
    // );
  };
  return (
    <React.Fragment>
      <div className="drivers-page">
        <Container fluid>
          <div className="">
            <Row
              xl={12}
              md={12}
              sm={12}
              xs={12}
              style={{ background: "#ffffff" }}
            >
              {" "}
              <Col xl={12} md={12} sm={12} xs={12}>
                {" "}
                <div className="stickyRowSettlements">
                  <div className="headerSettlements">
                    {/* <Breadcrumbs items={breadcrumbItems} /> */}
                    <div className="titleContainer">
                      <div className="greeting">High Roller Expediting</div>
                      <div style={{ marginTop: "8px", display: "flex" }}>
                        {/* <img
                          src={helloImage}
                          style={{
                            width: "34px",
                            height: "34px",
                            marginRight: "5px",
                          }}
                        /> */}
                        <Title
                          // name={`${firstNameUser} ${lastNameUser}`}
                          name={"Settlements"}
                          type={"page"}
                        />
                      </div>
                    </div>
                    <div className="calenderChangeButtonContainerSettelments">
                      <CalenderChanger
                        activeTab={activeCalendarTab}
                        onMonthChange={handleDateChange}
                        onQuarterChange={handleDateChange}
                        onYearChange={handleDateChange}
                      />
                    </div>
                    <div className="stickyTabButtonsSettelments">
                      <TabButtons
                        tabs={calendarTabsData}
                        onTabChange={handleTabChange}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "24px" }}>
                    <DetailsHeader data={driverData} />
                  </div>
                  <div
                    className="tableTitleContainerSettlements"
                    style={{ width: "100%" }}
                  >
                    {" "}
                    <div style={{ flex: "1" }}>
                      <Title name={"Weekly Settlements"} type={"table"} />
                    </div>
                    {/* <div style={{ flex: "" }} className="searchBox">
                      <img src={searchIcon} />
                      <input
                        type="text"
                        placeholder="Search upload Id."
                        className="searchTextStyle"
                        style={{
                          border: "none",
                          background: "#fcfcfc",
                          padding: "0",
                        }}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="tableContainerSettlements">
                  <div
                    className="driversTableContainerSettlements"
                    style={{
                      maxHeight: `${maxTableHeight}px`,
                      width: "100%",
                      padding: "0 16px 0 16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div className="recentSettelmentsTableContainer">
                      <DriversTablePOC
                        headers={settlementsTableHeaders}
                        data={settlementsTableData}
                        activeTab={activeTab}
                        settlementsUploadId={settlementsUploadId}
                        rowClick={true}
                        tableName={"settelmentsPOC"}
                        paginationEnabled={true}
                        currentPage={currentPageSettlementsPOC}
                        itemsPerPage={itemsPerPageSettlementsPOC}
                        onPageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        onNavigateAway={handleNavigateAway}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default SettlementsPOC;
